import { Component, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import Lottie from 'lottie-web';
import { HelperService } from '../../../../shared/services/helper.service';
import { RouteNames } from '../../../../shared/routing/app-routing.constants';

@Component({
  selector: 'app-advice-nonhappy-flow',
  templateUrl: './advice-nonhappy-flow.component.html',
  styleUrls: ['../blocked/blocked.component.scss']
})
export class AdviceNonhappyFlowComponent implements AfterViewInit {
  asset = './assets/unauthorized-user-blocked.json';
  
  constructor(
    private readonly helperService: HelperService,
    private readonly router: Router
  ) { }

  ngAfterViewInit(): void {
    const svgContainer = document.getElementById('jsonImageIcon');
    Lottie.loadAnimation(this.helperService.getLottieConfig(svgContainer, false, true, 'no-product', this.asset));
  }

  nextAction(_event: string): void | boolean {
    void this.router.navigate(['/'+ RouteNames.customerZone + '/' + RouteNames.customerHome]);
  }  
}
